export default __webpack_public_path__ + "static/media/web.cb3d085a.png";